/**
 * Created by nguyendx 2017/10/16.
 */
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Router} from '@angular/router';
import {ApiEvsService} from './ApiEvs.service';
import {environment} from '../../../environments/environment';

@Injectable()
export class EvsScanStampService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
    this.setEndPoint('/stamps');
  }

  scanQrm(data: any) {
    return this.postNoToken('/stamps/scan-qrm', data);
  }

  scanCodeId(data: any) {
    return this.postNoToken('/stamps/scan', data);
  }

  getVendor(barcode: string) {
    return this.getFullUrl(environment.apiIcheck + '/scan/' + barcode);
  }

  getProuctInfo(sku: string) {
    return this.getFromiCheck(environment.apiIcheck + '/scan/' + sku);
  }

  updateBaoHanh(data: any) {
    return this.post('/stamps/customer', data);
  }
}



// WEBPACK FOOTER //
// /app/src/app/common/services/EvsScanStamp.service.ts